import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const IconClose = ({ className, fill = 'currentColor' }) => {
    return (
        <svg
            className={className}
            fill='none'
            height='14'
            viewBox='0 0 14 14'
            width='14'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M3.90786 10.8532L3.14661 10.0919L6.22827 6.9894L3.14661 3.90774L3.90786 3.14648L7.01036 6.22815L10.092 3.14648L10.8533 3.90774L7.77161 6.9894L10.8533 10.0919L10.092 10.8532L7.01036 7.77149L3.90786 10.8532Z'
                fill={fill}/>
        </svg>


    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconClose;
